const data = [
    { id: "PIX", name: "PIX" },
    { id: "CREDITO", name: "Crédito" },
    { id: "DEBITO", name: "Débito" },
    { id: "SALDO_USUARIO", name: "Saldo" }
]

export default [...data]